<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Aviso de privacidad</h1>

      <p>
        En Blackfon, la privacidad de nuestros clientes es nuestra prioridad. Este Aviso de Privacidad explica cómo recopilamos, utilizamos y protegemos tu información personal al interactuar con nuestro sitio web y servicios de comercio electrónico.
      </p>

      <br />
      <h6>1. Responsable del tratamiento de datos</h6>
      <p>
        Blackfon, con domicilio en [Dirección], es responsable del tratamiento de tus datos personales conforme a las disposiciones de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).
      </p>

      <br />
      <h6>2. Datos que recopilamos</h6>
      <p>
        Podemos recopilar la siguiente información cuando navegas por nuestro sitio o realizas una compra:
      </p>
      <ul>
        <li>
          <strong>Datos de identificación:</strong> Nombre, apellidos, fecha de nacimiento.
        </li>
        <li>
          <strong>Datos de contacto:</strong> Correo electrónico, número de teléfono, dirección de envío y facturación.
        </li>
        <li>
          <strong>Datos de pago:</strong> Información de tarjeta de crédito/débito (procesada por proveedores de pago seguros).
        </li>
        <li>
          <strong>Datos de navegación:</strong> Dirección IP, cookies y comportamiento dentro del sitio web.
        </li>
      </ul>

      <br />
      <h6>3. Finalidad del tratamiento de datos</h6>
      <p>
        Utilizamos tus datos personales para los siguientes fines:
      </p>
      <ul>
        <li>
          Procesar y entregar tus pedidos.
        </li>
        <li>
          Ofrecer atención al cliente y gestionar cambios o devoluciones.
        </li>
        <li>
          Enviar promociones, descuentos y novedades (si aceptas recibir comunicaciones).
        </li>
        <li>
          Cumplir con requisitos legales y fiscales.
        </li>
      </ul>

      <br />
      <h6>4. Protección de datos personales</h6>
      <p>
        Implementamos medidas de seguridad para proteger tu información contra accesos no autorizados, pérdidas o alteraciones.
      </p>

      <br />
      <h6>5. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</h6>
      <p>
        Tienes derecho a solicitar acceso, corrección, eliminación o restricción del uso de tus datos enviando un correo a contacto@blackfon.mx
      </p>

      <br />
      <h6>6. Uso de cookies</h6>
      <p>
        Utilizamos cookies para mejorar tu experiencia en nuestro sitio. Puedes gestionarlas desde la configuración de tu navegador.
      </p>

      <br />
      <h6>7. Cambios en el Aviso de Privacidad</h6>
      <p>
        Nos reservamos el derecho de modificar este Aviso en cualquier momento. Te notificaremos cualquier actualización en nuestro sitio web.
      </p>

      <br />
      <p>
        Para cualquier consulta sobre este Aviso de Privacidad, contáctanos en contacto@blackfon.mx
      </p>

    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
